import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';
import { sortByAttribute } from '#utils/sorting';

export const GET_ACCOUNT = gql`
  query GetAccount {
    viewer {
      id
      email
      flags {
        isOnboarded
      }
    }
    installations {
      nodes {
        id
        status
        manageUrl
        profile {
          id
          url
          name
          avatarUrl
        }
      }
    }
  }
`;

export const useAccountQuery = () => {
  const { data, loading, refetch } = useQuery(GET_ACCOUNT);
  const account = data?.viewer;
  const installations = data?.installations?.nodes;

  const sortedInstallations = useMemo(() => {
    if (!installations) {
      return undefined;
    }
    return sortByAttribute(installations, 'profile.name');
  }, [installations]);

  return {
    account,
    installations: sortedInstallations,
    loading,
    refetch,
  };
};
